"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var Tokenizer_1 = __importDefault(require("./Tokenizer"));

var Program_1 = __importDefault(require("./ast/Program"));

function compile(input) {
  var tokenizer = new Tokenizer_1["default"](input);
  var program = new Program_1["default"](tokenizer);
  program.parse();
  program.typeCheck();
  return program.evaluate();
}

exports["default"] = compile;